import { SPEED } from '../config/gameConfig';

export class BoostSystem {
  private activeMs = 0;
  private cooldownMs = 0;

  reset(): void {
    this.activeMs = 0;
    this.cooldownMs = 0;
  }

  get isActive(): boolean {
    return this.activeMs > 0;
  }

  get isReady(): boolean {
    return this.activeMs <= 0 && this.cooldownMs <= 0;
  }

  /** 1 = full ready/active, 0 = empty during cooldown. */
  get ratio(): number {
    if (this.activeMs > 0) return this.activeMs / SPEED.boostDurationMs;
    if (this.cooldownMs > 0) return 1 - this.cooldownMs / SPEED.boostCooldownMs;
    return 1;
  }

  tryActivate(): boolean {
    if (!this.isReady) return false;
    this.activeMs = SPEED.boostDurationMs;
    return true;
  }

  update(deltaMs: number): void {
    if (this.activeMs > 0) {
      this.activeMs = Math.max(0, this.activeMs - deltaMs);
      if (this.activeMs === 0) {
        this.cooldownMs = SPEED.boostCooldownMs;
      }
      return;
    }
    if (this.cooldownMs > 0) {
      this.cooldownMs = Math.max(0, this.cooldownMs - deltaMs);
    }
  }

  speedMultiplier(): number {
    return this.isActive ? SPEED.boostMultiplier : 1;
  }
}
